import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const DoubleReview = () => {
  return (
    <Container>


    <h2 className="display-6 fw-bold my-4">
    Double-blind peer-review
    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      Double-blind review means the identities of the authors are concealed from the reviewers, and vice versa. To facilitate this, please include the following separately: <br/>
Title page <i>(with author details)</i>: This should include the title, authors’ names, affiliations, acknowledgements and any Declaration of Interest statement, and a complete address for the corresponding author including an e-mail address.<br/>
Blinded manuscript <i>(no author details)</i>: The main body of the paper (including the references, figures, tables and any acknowledgements) should not include any identifying information, such as the authors’ names or affiliations.
      </p>
      <p className="joab-common-para my-4 ">
      On submission, the manuscript is assigned to an editor covering the subject area, who seeks informal advice from scientific advisors and editorial colleagues, and who makes this initial decision. The initial judgment is not a reflection on the technical validity of the work described, or on its importance to people in the same field.
      </p>
      <p className="joab-common-para my-4 ">
      Once the decision has been made to peer-review the paper, the choice of referees is made by the editor who has been assigned the manuscript, who will be handling other papers in the same field, in consultation with editors handling submissions in related fields when necessary. Most papers are sent to two or three referees.
      </p>
   
    

  </Container>
  );
};

export default DoubleReview;
